export default function Image({ style, ...props }) {
  return (
    <img
      alt=""
      style={{
        display: 'block',
        height: 'auto',
        marginLeft: 'auto',
        marginRight: 'auto',
        maxWidth: '100%',
        verticalAlign: 'middle',
        ...style,
      }}
      {...props}
    />
  )
}
